<script>
import Drawer from "@/components/drawer";
import moment from "moment";

// Custom components
import PageHeader from "@/components/page-header";
import Room from "@/components/inventory/room.vue";
import RoomMiniBar from "@/components/RoomMiniBar/RoomMiniBar.vue";
import BookingDetails from "@/components/booking-details.vue";
import UserService from "@/helpers/APIService/user.service";
import RoomService from "@/helpers/APIService/room.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { hk_status, occupancy_status } from "@/helpers/global.variable";
import { authComputed, authMethods } from "@/state/helpers";
import appConfig from "@/app.config";

// Room Component

export default {
  page: {
    title: "Room",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    PageHeader,
    Room,
    RoomMiniBar,
    BookingDetails,
  },
  data() {
    return {
      title: "Room",
      isDataLoading: true,
      openNewRoomForm: false,
      table: {
        tableData: [],
      },
      hk_status,
      occupancy_status,
      roomType: [],
      buildingOptions: [],
      selectedRoom: null,
      roomEdit: false,
      openMinibar: false,
      isKHStatusChange: false,
      isOccupancyStatusChange: false,
      changeRoomStatusId: "",
      popoverShow: false,
      showBookingData: "",
      selectedBooking: "",
      viewBookingDetails: false,
      filterIdClicked: "v",
      syncLastTime: "",
      isDataSyncing: false,
      roomFilterBtn: [],
      totalRooms: 0,
    };
  },
  computed: {
    ...authComputed,
    roomProps() {
      return {
        roomType: this.roomType,
        building: this.buildingOptions,
        selectedRoom: this.selectedRoom,
        roomEdit: this.roomEdit,
      };
    },
    miniBarProps() {
      return {
        selectedRoom: this.selectedRoom,
      };
    },
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
  },
  mounted() {
    this.getBuildingListData();
    this.getRoomTypeNameList();
    this.getPMSConnection();
  },
  methods: {
    ...authMethods,
    // Method is use for get building list
    async getBuildingListData() {
      await RoomService.getBuildingList()
        .then((building) => {
          building.map((item) => {
            this.buildingOptions.push({
              value: item.id,
              text: item.short_name + "-" + item.name,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for get all rooms
    getRooms(status = "v") {
      this.isDataLoading = true;
      RoomService.getRoomList()
        .then((room) => {
          this.totalRooms = [];
          let roomToBeShow = [];
          this.totalRooms = room.length;
          this.roomFilterBtn = this.occupancy_status.map((ocpStatus) => {
            let total = 0;
            room.map((item) => {
              if (item.occupancy_status == ocpStatus.value) {
                total += 1;
              }
              if (status !== "all") {
                if (item.occupancy_status == status) {
                  roomToBeShow.push(item);
                }
              } else {
                roomToBeShow.push(item);
              }
            });
            ocpStatus = { ...ocpStatus, total };
            return ocpStatus;
          });
          this.roomFilterBtn = this.roomFilterBtn.filter(
            (item) => item.value !== "oos" && item.value !== "b"
          );
          var unique = roomToBeShow.filter(function (item, i, ar) {
            return ar.indexOf(item) === i;
          });
          this.table.tableData = unique;
          this.isDataLoading = false;
        })
        .catch((error) => {
          this.isDataLoading = false;
          errorHandler(error);
        });
    },
    // Method is use for maintained room type
    async getRoomTypeNameList() {
      await RoomService.getRoomTypeList()
        .then((response) => {
          response.map((item) => {
            let tempRoomType = {
              value: item.id,
              text: item.short_name + " - " + item.name,
            };
            this.roomType.push(tempRoomType);
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for open an add new room
    newRoomForm() {
      if (this.openNewRoomForm == true) {
        this.selectedRoom = null;
        this.roomEdit = false;
      }
      this.openNewRoomForm = !this.openNewRoomForm;
    },
    // Method is use for add and update room
    roomCreated(room, roomEdit) {
      if (roomEdit) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id === room.id) {
            item = room;
          }
          return item;
        });
        Middleware.notification("Successfully updated !!", "success");
      } else {
        if (Array.isArray(room)) {
          room.map((item) => {
            this.table.tableData.push(item);
          });
        } else {
          this.table.tableData.push(room);
        }
        Middleware.notification("Successfully created !!", "success");
      }
      // this.roomTable.tableData.push(room);

      this.newRoomForm();
    },
    // Method is use for save and add new room continue
    saveAndAddNewRoom(room) {
      this.table.tableData.push(room);
      Middleware.notification("Successfully created !!", "success");
    },
    // edit room
    editRoom(room) {
      this.selectedRoom = room;
      this.roomEdit = true;
      this.newRoomForm();
    },
    // Method is use for change hk status
    changeHouseKeepingStatus(data) {
      RoomService.editRoom({ hk_status: data.hk_status }, data.id)
        .then(() => {
          Middleware.notification("Status changed successfully !!", "success");

          this.isKHStatusChange = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for change occupancy status status
    changeOccupancyStatus(data) {
      if (data.occupancy_status == "ooo" || data.occupancy_status == "oos") {
        this.editRoom(data);
        this.isOccupancyStatusChange = false;
      } else {
        RoomService.editRoom(
          { occupancy_status: data.occupancy_status },
          data.id
        )
          .then(() => {
            Middleware.notification(
              "Status changed successfully !!",
              "success"
            );

            this.isOccupancyStatusChange = false;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    // Method is use for open a mini bar drawer
    miniBarIsOpen() {
      this.openMinibar = !this.openMinibar;
    },
    // Method is use for manage mini bar item
    miniBarDrawer(room) {
      this.selectedRoom = room.id;
      this.miniBarIsOpen();
    },
    openPopover(e = null) {
      if (e == null) {
        this.selectedBooking = "";
      } else {
        this.$root.$emit("bv::show::popover", e.target.id);
      }
    },
    closePopover(e) {
      this.selectedBooking = "";
      this.$root.$emit("bv::hide::popover", e.target.id);
    },
    // Method is used to open booking detail page
    async openBookingDetails(data = null, e) {
      if (data != null) {
        this.closePopover(e);
        this.selectedBooking = data;
      }
      this.viewBookingDetails = !this.viewBookingDetails;
    },
    // Method is used to filter room
    filterRoomByOsStatus(status) {
      this.filterIdClicked = status;
      this.getRooms(status);
    },
    // Method is used to GET PMS connection
    async getPMSConnection(data) {
      try {
        if (this.hotel.is_pms_connection) {
          if (data !== undefined) {
            let interValId = "";
            interValId = setInterval(() => {
              const filter = "?operation_type=room&size=1";
              UserService.getPMSSyncRecord(filter).then((pmsResponse) => {
                if (
                  moment(data.pms_room_status_updated_at).format(
                    "YYYY MM DD HH:mm:ss"
                  ) !==
                  moment(pmsResponse.pms_room_status_updated_at).format(
                    "YYYY MM DD HH:mm:ss"
                  )
                ) {
                  this.isDataSyncing = false;
                  clearInterval(interValId);
                  Middleware.notification(
                    "New data synced successfully !!",
                    "success"
                  );

                  this.getRooms();
                } else {
                  this.syncLastTime = moment(
                    pmsResponse.pms_room_status_updated_at
                  ).fromNow();
                  this.isDataSyncing = true;
                }
              });
            }, 7000);
          } else {
            this.syncLastTime = "Not Synced";
            this.isDataSyncing = false;
          }
        }
      } catch (error) {
        if (error.response.status !== 404) {
          errorHandler(error);
        } else {
          this.isDataSyncing = false;
        }
      }
    },
    // Method is used to sync PMS room
    async syncPmsRecord() {
      try {
        this.isDataSyncing = true;
        const response = await UserService.syncPMSRoomRecords();
        if (response !== null || response !== undefined) {
          this.getPMSConnection(response);
        }
      } catch (error) {
        errorHandler(error);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="newRoomForm"
      text="Add New Room"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-item-center">
              <div class="col-md-8">
                <div class="d-flex flex-wrap align-items-center">
                  <b-button
                    v-for="(btnOS, index) in roomFilterBtn"
                    :variant="
                      btnOS.value == 'v'
                        ? filterIdClicked == 'v'
                          ? 'primary'
                          : 'outline-primary'
                        : btnOS.value == 'o'
                        ? filterIdClicked == 'o'
                          ? 'success'
                          : 'outline-success'
                        : btnOS.value == 'b'
                        ? filterIdClicked == 'b'
                          ? 'secondary'
                          : 'outline-secondary'
                        : btnOS.value == 'ooo'
                        ? filterIdClicked == 'ooo'
                          ? 'warning'
                          : 'outline-warning'
                        : 'outline-dark'
                    "
                    class="me-2 mb-2"
                    :key="index"
                    @click="filterRoomByOsStatus(btnOS.value)"
                    >{{ btnOS.text + " " }}({{ btnOS.total }})</b-button
                  >
                  <b-button
                    :variant="
                      filterIdClicked == 'all' ? 'dark' : 'outline-dark'
                    "
                    class="me-2 mb-2"
                    @click="filterRoomByOsStatus('all')"
                    >All ({{ totalRooms }})</b-button
                  >
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="d-flex flex-wrap align-items-center justify-content-end"
                  v-if="hotel.is_pms_connection"
                >
                  <button
                    class="btn btn-primary"
                    @click="syncPmsRecord"
                    :disabled="isDataSyncing"
                  >
                    <i
                      v-if="isDataSyncing"
                      class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    ></i>
                    {{ isDataSyncing ? "Syncing" : "PMS Room Sync" }}
                  </button>
                  <div class="d-flex align-items-center">
                    <i
                      v-if="!isDataSyncing"
                      class="fa fa-info-circle mb-0 ms-1"
                      v-b-popover.hover.top="
                        'Press button to sync new room status'
                      "
                    ></i>
                    <p class="mb-0 fs-6 ms-1">{{ syncLastTime }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-2">
                <!-- Table -->
                <div class="table-responsive mb-0" v-dragscroll>
                  <v-table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getRooms"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                    :data="table.tableData"
                  >
                    <thead class="table-light" slot="head">
                      <tr>
                        <v-th sortKey="room_number">Room</v-th>
                        <th>Guest Name</th>
                        <th>Room Type</th>
                        <th>Floor</th>
                        <th>Available</th>
                        <th>Occupancy Status</th>
                        <th>Occupancy Reason</th>
                        <th>HK Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isDataLoading">
                      <tr v-for="item in 20" :key="item">
                        <td class="placeholder-glow" v-for="no in 9" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      class="infinite-list"
                      slot="body"
                      slot-scope="{ displayData }"
                      v-if="table.tableData.length > 0 && !isDataLoading"
                    >
                      <tr v-for="(data, index) in displayData" :key="index">
                        <td @click="editRoom(data)">
                          {{ data.room_number }}
                          <i
                            class="fas fa-exchange-alt"
                            v-if="
                              data.connect_room_number !== 'null' &&
                              data.connect_room_number !== null
                            "
                          ></i>
                          {{
                            data.connect_room_number !== "null" &&
                            data.connect_room_number !== null
                              ? data.connect_room_number
                              : ""
                          }}
                        </td>
                        <td>
                          <span v-if="data.booking !== null">
                            {{
                              data.booking.last_name !== null
                                ? data.booking.last_name
                                : ""
                            }}
                            {{
                              +" " + data.booking.first_name !== null
                                ? data.booking.first_name
                                : ""
                            }}
                            <i
                              :id="data.booking.id"
                              type="button"
                              class="fa fa-info-circle mb-0"
                              @click="openPopover($event)"
                            ></i>
                            <b-popover
                              :target="data.booking.id"
                              triggers="click"
                              placement="auto"
                              container="my-container"
                              ref="popover"
                            >
                              <template #title>
                                <div class="d-flex align-items-center">
                                  Booking Information
                                  <i
                                    class="fa fa-info-circle mb-0 ms-1 me-2"
                                    @click="
                                      openBookingDetails(data.booking, $event)
                                    "
                                  ></i>
                                  <i
                                    class="fas fa-window-close float-end"
                                    @click="closePopover($event)"
                                  ></i>
                                </div>
                              </template>
                              <div>
                                <div class="fs-6 mb-1">
                                  <span class="popover-text fw-medium"
                                    >Ref No</span
                                  >
                                  <span class="mx-2">:</span>
                                  <span class=""
                                    >#{{ data.booking.reference_no }}</span
                                  >
                                </div>

                                <div
                                  class="fs-6 mb-1"
                                  v-show="
                                    data.booking.booking_source_reference_no !==
                                    null
                                  "
                                >
                                  <span class="popover-text fw-medium"
                                    >PMS Ref No</span
                                  >
                                  <span class="mx-2">:</span>
                                  #{{
                                    data.booking.booking_source_reference_no
                                  }}
                                </div>
                                <div class="fs-6 mb-1">
                                  <span class="popover-text fw-medium">
                                    Name
                                  </span>
                                  <span class="mx-2">:</span>
                                  <span class="fw-normal"
                                    >{{ data.booking.first_name }}
                                    {{ data.booking.last_name }}</span
                                  >
                                </div>
                                <div class="fs-6 mb-1">
                                  <span class="popover-text fw-medium"
                                    >Arrive
                                  </span>
                                  <span class="mx-2">:</span>
                                  <span class="fw-normal"
                                    >{{
                                      global_format_date(
                                        data.booking.check_in_date
                                      )
                                    }}
                                  </span>
                                </div>
                                <div class="fs-6 mb-1">
                                  <span class="popover-text fw-medium"
                                    >Depart</span
                                  >
                                  <span class="mx-2">:</span>
                                  <span class="fw-normal"
                                    >{{
                                      global_format_date(
                                        data.booking.check_out_date
                                      )
                                    }}
                                  </span>
                                </div>
                              </div>
                            </b-popover>
                          </span>
                          <span v-else>{{ "-" }}</span>
                        </td>
                        <td @click="editRoom(data)">
                          {{ data.room_type.short_name }} -
                          {{ data.room_type.name }}
                        </td>
                        <td @click="editRoom(data)">
                          {{ data.floor.name }}
                        </td>
                        <td @click="editRoom(data)">
                          <i
                            class="fas fa-wheelchair text-primary fs-5 me-3"
                            v-if="data.is_accessible"
                          ></i>
                          <i
                            class="fas fa-paw text-primary fs-5 me-3"
                            v-if="data.is_pet_friendly"
                          ></i>
                          <i
                            class="fas fa-smoking text-primary fs-5 me-3"
                            v-if="data.is_smoking"
                          ></i>
                          {{
                            data.is_accessible ||
                            data.is_pet_friendly ||
                            data.is_smoking
                              ? ""
                              : "-"
                          }}
                        </td>
                        <td
                          @dblclick="
                            () => {
                              isOccupancyStatusChange = true;
                              changeRoomStatusId = data.id;
                            }
                          "
                        >
                          <div
                            class="col-md-6"
                            v-if="
                              isOccupancyStatusChange &&
                              changeRoomStatusId == data.id
                            "
                          >
                            <b-form-select
                              class="form-select"
                              id="building"
                              type="text"
                              autocomplete="off"
                              v-model="data.occupancy_status"
                              :options="occupancy_status"
                              @change="changeOccupancyStatus(data)"
                            >
                            </b-form-select>
                          </div>
                          <span
                            @click="
                              () => {
                                isOccupancyStatusChange = false;
                                changeRoomStatusId = '';
                              }
                            "
                            v-else
                            class="badge align-items-center py-1 px-2 card-badge"
                            :class="[
                              data.occupancy_status == 'v'
                                ? 'badge-soft-primary'
                                : data.occupancy_status == 'o'
                                ? 'badge-soft-success'
                                : data.occupancy_status == 'b'
                                ? 'badge-soft-dark'
                                : data.occupancy_status == 'ooo'
                                ? 'badge-soft-warning'
                                : data.occupancy_status == 'oos'
                                ? 'badge-soft-danger'
                                : 'badge-soft-dark',
                            ]"
                          >
                            {{
                              data.occupancy_status == "v"
                                ? "Vacant"
                                : data.occupancy_status == "o"
                                ? "Occupied"
                                : data.occupancy_status == "b"
                                ? "Blocked"
                                : data.occupancy_status == "ooo"
                                ? "Out of Order"
                                : "Out of Service"
                            }}
                          </span>
                        </td>
                        <td @click="editRoom(data)">
                          {{
                            data.occupancy_reason != null
                              ? data.occupancy_reason
                              : "-"
                          }}
                        </td>
                        <td
                          @dblclick="
                            () => {
                              isKHStatusChange = true;
                              changeRoomStatusId = data.id;
                            }
                          "
                        >
                          <div
                            class="col-md-6"
                            v-if="
                              isKHStatusChange && changeRoomStatusId == data.id
                            "
                          >
                            <b-form-select
                              class="form-select w-90"
                              id="building"
                              type="text"
                              autocomplete="off"
                              v-model="data.hk_status"
                              :options="hk_status"
                              @change="changeHouseKeepingStatus(data)"
                            >
                            </b-form-select>
                          </div>
                          <span
                            @click="
                              () => {
                                isKHStatusChange = false;
                                changeRoomStatusId = '';
                              }
                            "
                            v-else
                            class="badge align-items-center py-1 px-2 card-badge"
                            :class="[
                              data.hk_status == 'p'
                                ? 'badge-soft-warning'
                                : data.hk_status == 'c'
                                ? 'badge-soft-success'
                                : data.hk_status == 'd'
                                ? 'badge-soft-dark'
                                : 'badge-soft-danger',
                            ]"
                          >
                            {{
                              data.hk_status == "p"
                                ? "Pickup"
                                : data.hk_status == "c"
                                ? "Clean"
                                : "Dirty"
                            }}
                          </span>
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success me-2"
                              title="Edit"
                              @click="editRoom(data)"
                            ></i>
                            <i
                              class="fas fa-glass-cheers text-primary"
                              title="Mini Bar"
                              @click="miniBarDrawer(data)"
                            >
                            </i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer is used to add and update room -->
    <Drawer
      @close="newRoomForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewRoomForm">
        <div class="offcanvas-body">
          <Room
            :currentProps="roomProps"
            @submitted="roomCreated"
            @cancelSubmit="newRoomForm"
            @saveAndAddNew="saveAndAddNewRoom"
          ></Room>
        </div>
      </div>
    </Drawer>

    <!-- Drawer is use for mini bar -->
    <Drawer
      @close="miniBarIsOpen"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1050"
    >
      <div v-if="openMinibar">
        <RoomMiniBar :currentProps="miniBarProps" />
      </div>
    </Drawer>

    <!-- Method is use for open drawer -->
    <Drawer
      @close="openBookingDetails"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1340"
      class="w-100"
    >
      <div v-if="viewBookingDetails">
        <BookingDetails :currentProps="bookingDetailsProps" />
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.popover-text {
  display: inline-block;
  width: 76px;
}
.w-90 {
  width: 90px;
}
</style>
